import { graphql, Link, useStaticQuery } from 'gatsby'
import React from 'react'
import { List } from './List'

export const RecentPostsGroup = () => {
  const data = useStaticQuery(graphql`
    {
      allMarkdownRemark(sort: { frontmatter: { date: DESC } }, limit: 5) {
        nodes {
          frontmatter {
            title
          }
          fields {
            slug
          }
        }
      }
    }
  `)

  const posts = data.allMarkdownRemark.nodes.map((node) => {
    return {
      title: node.frontmatter.title,
      slug: node.fields.slug,
    }
  })

  return (
    <List title="Recent Posts">
      {posts.map(({ title, slug }) => {
        return (
          <List.Item key={title}>
            <Link to={slug}>{title}</Link>
          </List.Item>
        )
      })}
    </List>
  )
}
